// date format as DD.MM.YY
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDateToDDMMYY(date: string | number | Date): string {
    let dayjsDate;

    if (typeof date === 'number') {
        // Handle both millisecond and second timestamps
        dayjsDate = dayjs(date < 10000000000 ? date * 1000 : date);
    } else if (typeof date === 'string' && /^\d+$/.test(date)) {
        // Handle numeric strings as timestamps
        const timestamp = parseInt(date, 10);
        dayjsDate = dayjs(
            timestamp < 10000000000 ? timestamp * 1000 : timestamp
        );
    } else {
        dayjsDate = dayjs(date);
    }

    // Use local timezone for formatting
    const localTimezone = dayjs.tz.guess();
    return dayjsDate.isValid()
        ? dayjs.utc(dayjsDate.valueOf()).tz(localTimezone).format('DD.MM.YY')
        : '';
}

export const formatDateSplit = (
    date: string,
    format?: { time?: string; date?: string; month?: string }
) => {
    // Use local timezone for formatting
    const localTimezone = dayjs.tz.guess();
    const localDate = dayjs.utc(date).tz(localTimezone);

    return {
        time: localDate.format(format?.time ?? 'h:mmA'),
        date: localDate.format(format?.date ?? 'ddd D MMM YYYY'),
        month: localDate.format(format?.month ?? 'MMMM YYYY'),
    };
};
